import * as appConstant from "../../constants/appConstant";

export function campaignsTranslatedDropdownList(dropdownOption, intl) {
    switch (dropdownOption) {
        case appConstant.DROPDOWN_OFFER_CONDITION :
            return [
                {
                    value: null,
                    label: intl.formatMessage({id: "campaigns.dropdown.options.select"})
                },
                {
                    value: "BRAND_CARD_SIGNUP_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.brand.card.signup"})
                },
                {
                    value: "BRAND_CARD_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.brand.card.specific"})
                },
                {
                    value: "COMBO CODE",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.combo.code"})
                },
                {
                    value: "DEMOGRAPHICS",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.demographics"})
                },
                {
                    value: "EMAIL_SIGNUP_REQUIRED",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.email.signup.required"})
                },
                {
                    value: "LOCATION_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.location.specific"})
                },
                {
                    value: "LOYALTY_REQUIRED",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.loyalty.required"})
                },
                {
                    value: "MEMBERSHIP_REQUIRED",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.membership.required"})
                },
                {
                    value: "MULTI_BUY",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.multi.buy"})
                },
                {
                    value: "NEW_CUSTOMER_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.new.customer.specific"})
                },
                {
                    value: "POINT_OF_SALE_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.point.of.sale.specific"})
                },
                {
                    value: "PRODUCT_SPECIFIC",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.product.specific"})
                },
                {
                    value: "PROMO_CODE",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.promo.code"})
                },
                {
                    value: "VANITY",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.vanity"})
                },
                {
                    value: "N/A",
                    label: intl.formatMessage({id: "campaigns.offer.condition.options.na"})
                },
            ]
        case appConstant.DROPDOWN_OFFER_TYPE:
            return [
                {
                    value: null,
                    label: intl.formatMessage({id: "campaigns.dropdown.options.select"})
                },
                {
                    value: "AMOUNT_OFF",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.amount.off"})
                },
                {
                    value: "BNPL (Buy Now Pay Later)",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.bnpl"})
                },
                {
                    value: "BOGO",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.bogo"})
                },
                {
                    value: "COUPON",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.coupon"})
                },
                {
                    value: "EVERGREEN",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.evergreen"})
                },
                {
                    value: "FREE_GIFT",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.free.gift"})
                },
                {
                    value: "FREE_SHIP",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.free.ship"})
                },
                {
                    value: "INTRODUCTORY_OFFER",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.introductory.offer"})
                },
                {
                    value: "PERCENT_OFF",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.percent.off"})
                },
                {
                    value: "PRODUCT",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.product"})
                },
                {
                    value: "PUBLISHER EXCLUSIVE",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.publisher.exclusive"})
                },
                {
                    value: "SUBSCRIPTION",
                    label: intl.formatMessage({id: "campaigns.offer.type.options.subscription"})
                }
            ]
        case appConstant.DROPDOWN_EVENTS:
            return [
                {
                    value: null,
                    label: intl.formatMessage({id: "campaigns.dropdown.options.select"})
                },
                {
                    value: 'August Bank Holiday',
                    label: intl.formatMessage({id: "campaigns.events.options.august.bank.holiday"})
                },
                {
                    value: 'Back to School',
                    label: intl.formatMessage({id: "campaigns.events.options.back.to.school"})
                },
                {
                    value: 'Black Friday',
                    label: intl.formatMessage({id: "campaigns.events.options.black.friday"})
                },
                {
                    value: 'Blue Monday (January)',
                    label: intl.formatMessage({id: "campaigns.events.options.blue.monday"})
                },
                {
                    value: 'Boxing Day',
                    label: intl.formatMessage({id: "campaigns.events.options.boxing.day"})
                },
                {
                    value: 'Cheltenham Festival',
                    label: intl.formatMessage({id: "campaigns.events.options.cheltenham.festival"})
                },
                {
                    value: 'Christmas',
                    label: intl.formatMessage({id: "campaigns.events.options.christmas"})
                },
                {
                    value: 'Cyber Monday',
                    label: intl.formatMessage({id: "campaigns.events.options.cyber.monday"})
                },
                {
                    value: 'Cyber/Giving Tuesday',
                    label: intl.formatMessage({id: "campaigns.events.options.cyber.giving.tuesday"})
                },
                {
                    value: 'Early May Bank Holiday',
                    label: intl.formatMessage({id: "campaigns.events.options.early.may.bank.holiday"})
                },
                {
                    value: 'Easter',
                    label: intl.formatMessage({id: "campaigns.events.options.easter"})
                },
                {
                    value: 'FA Cup',
                    label: intl.formatMessage({id: "campaigns.events.options.fa.cup"})
                },
                {
                    value: 'Father\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.fathers.day"})
                },
                {
                    value: 'Grand National',
                    label: intl.formatMessage({id: "campaigns.events.options.grand.national"})
                },
                {
                    value: 'Halloween',
                    label: intl.formatMessage({id: "campaigns.events.options.halloween"})
                },
                {
                    value: 'Holiday',
                    label: intl.formatMessage({id: "campaigns.events.options.holiday"})
                },
                {
                    value: 'Independence Day',
                    label: intl.formatMessage({id: "campaigns.events.options.independence.day"})
                },
                {
                    value: 'Labor Day',
                    label: intl.formatMessage({id: "campaigns.events.options.labor.day"})
                },
                {
                    value: 'Late May Bank Holiday',
                    label: intl.formatMessage({id: "campaigns.events.options.late.may.bank.holiday"})
                },
                {
                    value: 'Lunar New Year',
                    label: intl.formatMessage({id: "campaigns.events.options.lunar.new.year"})
                },
                {
                    value: 'Memorial Day',
                    label: intl.formatMessage({id: "campaigns.events.options.memorial.day"})
                },
                {
                    value: 'Mother\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.mothers.day"})
                },
                {
                    value: 'New Year',
                    label: intl.formatMessage({id: "campaigns.events.options.new.year"})
                },
                {
                    value: 'President\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.presidents.day"})
                },
                {
                    value: 'Product Launch',
                    label: intl.formatMessage({id: "campaigns.events.options.product.launch"})
                },
                {
                    value: 'Single\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.singles.day"})
                },
                {
                    value: 'St Patrick\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.st.patricks.day"})
                },
                {
                    value: 'Super Bowl',
                    label: intl.formatMessage({id: "campaigns.events.options.super.bowl"})
                },
                {
                    value: 'Tax Season',
                    label: intl.formatMessage({id: "campaigns.events.options.tax.season"})
                },
                {
                    value: 'Thanksgiving',
                    label: intl.formatMessage({id: "campaigns.events.options.thanksgiving"})
                },
                {
                    value: 'Valentine\'s Day',
                    label: intl.formatMessage({id: "campaigns.events.options.valentino"})
                },
                {
                    value: 'Wimbledon',
                    label: intl.formatMessage({id: "campaigns.events.options.wimbledon"})
                },
                {
                    value: 'World Cup',
                    label: intl.formatMessage({id: "campaigns.events.options.world.cup"})
                }
            ]
        case appConstant.DROPDOWN_PLACEMENT_STATUS :
            return [
                {
                    value: 'Booked',
                    label: intl.formatMessage({id: "campaigns.placement.status.options.booked"})
                }, {
                    value: 'Proposed',
                    label: intl.formatMessage({id: "campaigns.placement.status.options.proposed"})
                }, {
                    value: 'Declined',
                    label: intl.formatMessage({id: "campaigns.placement.status.options.declined"})
                }
            ]
        case appConstant.DROPDOWN_PROGRAM_TERM_PUSHED:
            return [
                {
                    value: null,
                    label: intl.formatMessage({id: "campaigns.dropdown.options.select"})
                },
                {
                    value: 'Yes',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.yes"})
                },
                {
                    value: 'No',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.no"})
                },
                {
                    value: 'N/A- Flat Fee Only',
                    label: intl.formatMessage({id: "campaigns.program.term.options.na.flat.fee.only"})
                }
            ]
        case appConstant.DROPDOWN_YES_NO_NA :
            return [
                {
                    value: null,
                    label: intl.formatMessage({id: "campaigns.dropdown.options.select"})
                },
                {
                    value: 'Yes',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.yes"})
                },
                {
                    value: 'No',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.no"})
                },
                {
                    value: 'N/A',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.na"})
                }
            ]
        case appConstant.DROPDOWN_PAID_IN_CJ :
            return [
                {
                    value: 'Fully Paid',
                    label: intl.formatMessage({id: "campaigns.paid.in.cj.options.fully.paid"})
                },
                {
                    value: 'Partially Paid',
                    label: intl.formatMessage({id: "campaigns.paid.in.cj.options.partially.paid"})
                }, {
                    value: 'Not Paid',
                    label: intl.formatMessage({id: "campaigns.paid.in.cj.options.not.paid"})
                }, {
                    value: 'CPA Increase Only',
                    label: intl.formatMessage({id: "campaigns.paid.in.cj.options.cpa.increase.only"})
                }, {
                    value: 'Make Good - No Cost',
                    label: intl.formatMessage({id: "campaigns.paid.in.cj.options.make.good.no.cost"})
                },
                {
                    value: 'N/A',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.na"})
                }
            ]
        case appConstant.DROPDOWN_YES_NO:
            return [
                {
                    value: 'Yes',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.yes"})
                },
                {
                    value: 'No',
                    label: intl.formatMessage({id: "campaigns.dropdown.options.no"})
                }
            ]
        case appConstant.DROPDOWN_DYNAMIC_OR_STATIC:
            return [
                {
                    value: 'Dynamic',
                    label: intl.formatMessage({id: "campaigns.dynamic.static.options.dynamic"})
                },
                {
                    value: 'Static',
                    label: intl.formatMessage({id: "campaigns.dynamic.static.options.static"})
                }
            ]
        case appConstant.DROPDOWN_NEW_OR_COMPED:
            return [
                {
                    value: 'Repeated',
                    label: intl.formatMessage({id: "campaigns.new.repeated.options.repeated"})
                },
                {
                    value: 'New',
                    label: intl.formatMessage({id: "campaigns.new.comped.options.new"})
                }
            ]
        case appConstant.DROPDOWN_PLACEMENT_TYPE:
            return [
                {
                    value: 'App Push',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.app.push'})
                },
                {
                    value: 'Article Inclusion',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.article.inclusion'})
                },
                {
                    value: 'Cashback Event',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.cashback.event'})
                },
                {
                    value: 'Category Leader',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.category.leader'})
                },
                {
                    value: 'Category Page',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.category.page'})
                },
                {
                    value: 'Content',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.content'})
                },
                {
                    value: 'Content - Dedicated Review',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.content.dedicated.review'})
                },
                {
                    value: 'Content - Editorial',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.content.editorial'})
                },
                {
                    value: 'Content - Gift Guide',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.content.gift.guide'})
                },
                {
                    value: 'Content - Multi Merchant Review',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.content.multi.merchant.review'})
                },
                {
                    value: 'Coupon Page',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.coupon.page'})
                },
                {
                    value: 'Deal Page',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.deal.page'})
                },
                {
                    value: 'Double Cashback',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.double.cashback'})
                },
                {
                    value: 'Footer Ads',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.footer.ads'})
                },
                {
                    value: 'Homepage',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.homepage'})
                },
                {
                    value: 'Homepage - Search Keywords',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.homepage.search.keywords'})
                },
                {
                    value: 'Homepage Carousel',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.homepage.carousel'})
                },
                {
                    value: 'Loyalty',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.loyalty'})
                },
                {
                    value: 'Make Good',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.make.good'})
                },
                {
                    value: 'Mobile App',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.mobile.app'})
                },
                {
                    value: 'Mobile Messaging',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.mobile.messaging'})
                },
                {
                    value: 'Mobile Webpage',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.mobile.webpage'})
                },
                {
                    value: 'Multi-Merchant Email',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.multi-merchant.email'})
                },
                {
                    value: 'Package',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.package'})
                },
                {
                    value: 'Pop-Up Ads',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.pop-up.ads'})
                },
                {
                    value: 'Search',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.search'})
                },
                {
                    value: 'Seasonal Event Page',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.seasonal.event.page'})
                },
                {
                    value: 'Social Media - Facebook',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.facebook'})
                },
                {
                    value: 'Social Media - Google+',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.google'})
                },
                {
                    value: 'Social Media - Instagram',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.instagram'})
                },
                {
                    value: 'Social Media - Snapchat',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.snapchat'})
                },
                {
                    value: 'Social Media - TikTok',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.tiktok'})
                },
                {
                    value: 'Social Media - Twitter',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.twitter'})
                },
                {
                    value: 'Social Media - WeChat',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.wechat'})
                },
                {
                    value: 'Social Media - Weibo',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.weibo'})
                },
                {
                    value: 'Social Media - YouTube',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.youtube'})
                },
                {
                    value: 'Social Media - Others',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.social.media.others'})
                },
                {
                    value: 'Solo Email',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.solo.email'})
                },
                {
                    value: 'Sponsored',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.sponsored'})
                },
                {
                    value: 'Staff Picks',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.staff.picks'})
                },
                {
                    value: 'Store Page Category',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.store.page.category'})
                },
                {
                    value: 'Widget',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.widget'})
                },
                {
                    value: 'Other',
                    label: intl.formatMessage({id: 'campaigns.placement.type.options.other'})
                }
            ]
        default:
            return ""
    }
}